import React from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";
import Image from "components/AppImage";
import { useLanguage } from "../../../LanguageContext"; // Adjust the import path

const ClientTable = ({
  clients,
  selectedClients,
  onSelectAll,
  onSelectClient,
  onDeleteClient,
  onRenewSubscription,
  allSelected,
}) => {
  const { language } = useLanguage();

  const permissions = JSON.parse(localStorage.getItem("permissions"));

  console.log(permissions);
  const updateClientExists = permissions.some(
    (permission) => permission.name === "update_client"
  );

  const deleteClientExists = permissions.some(
    (permission) => permission.name === "delete_client"
  );

  const translations = {
    client: language === "ar" ? "العميل" : "Client",
    phone: language === "ar" ? "الهاتف" : "Phone",
    status: language === "ar" ? "الحالة" : "Status",
    startDate: language === "ar" ? "تاريخ البدء" : "Start Date",
    endDate: language === "ar" ? "تاريخ الانتهاء" : "End Date",
    selectAll: language === "ar" ? "تحديد الكل" : "Select All",
    edit: language === "ar" ? "تعديل" : "Edit",
    renew: language === "ar" ? "تجديد" : "Renew",
    delete: language === "ar" ? "حذف" : "Delete",
  };

  const getStatusBadge = (status) => {
    const baseClasses =
      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium";

    switch (status) {
      case "active":
        return `${baseClasses} bg-green-100 text-green-800`;
      case "Ending Soon":
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case "inactive":
        return `${baseClasses} bg-red-100 text-red-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(
      language === "ar" ? "ar-SA" : "en-US",
      {
        year: "numeric",
        month: "short",
        day: "numeric",
      }
    );
  };

  return (
    <div className="overflow-hidden">
      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              {/* Uncomment if you want to include a checkbox for selecting all clients */}
              {/* <th className="px-6 py-3 text-center">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                />
              </th> */}
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.client}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.phone}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.status}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.startDate}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.endDate}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.actions}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {clients.map((client) => (
              <tr key={client.id} className="hover:bg-gray-50">
                {/* Uncomment if you want to include a checkbox for selecting individual clients */}
                {/* <td className="px-6 py-4">
                  <input
                    type="checkbox"
                    checked={selectedClients.includes(client.id)}
                    onChange={(e) =>
                      onSelectClient(client.id, e.target.checked)
                    }
                    className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                  />
                </td> */}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="ml-4">
                      <div className="text-sm font-medium text-gray-900">
                        {client.name}
                      </div>
                    </div>
                  </div>
                </td>

                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {client.phone}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={getStatusBadge(client.status)}>
                    {client.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {formatDate(client.start_date)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {formatDate(client.end_date)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex items-center space-x-2">
                    <Link
                      to={`/add-edit-client-profile?id=${client.id}`}
                      className="text-green-600 hover:text-green-900 p-1 rounded"
                      title={translations.edit}
                    >
                      <Icon name="Edit" size={16} />
                    </Link>
                    <button
                      onClick={() => onRenewSubscription(client.id)}
                      className="text-blue-600 hover:text-blue-900 p-1 rounded"
                      title={translations.renew}
                    >
                      <Icon name="RefreshCw" size={16} />
                    </button>
                    <button
                      onClick={() => onDeleteClient(client.id)}
                      className="text-red-600 hover:text-red-900 p-1 rounded"
                      title={translations.delete}
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="lg:hidden">
        <div className="p-4 bg-gray-50 border-b">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={(e) => onSelectAll(e.target.checked)}
              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded mr-2"
            />
            <span className="text-sm font-medium text-gray-700">
              {translations.selectAll}
            </span>
          </label>
        </div>

        <div className="divide-y divide-gray-200">
          {clients.map((client) => (
            <div key={client.id} className="p-4">
              <div className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  checked={selectedClients.includes(client.id)}
                  onChange={(e) => onSelectClient(client.id, e.target.checked)}
                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded mt-1"
                />

                <div className="flex-shrink-0">
                  <Image
                    src={client.avatar}
                    alt={client.name}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-medium text-gray-900 truncate">
                      {client.name}
                    </h3>
                    <span className={getStatusBadge(client.subscriptionStatus)}>
                      {client.subscriptionStatus}
                    </span>
                  </div>

                  <div className="mt-1 space-y-1">
                    <p className="text-sm text-gray-500">{client.email}</p>
                    <p className="text-sm text-gray-500">{client.phone}</p>
                    <p className="text-sm text-gray-500">Age: {client.age}</p>
                    <p className="text-sm text-gray-500">
                      {formatDate(client.start_date)} -{" "}
                      {formatDate(client.end_date)}
                    </p>
                  </div>

                  <div className="mt-3 flex items-center space-x-4">
                    {updateClientExists && (
                      <Link
                        to={`/add-edit-client-profile?id=${client.id}`}
                        className="text-green-600 hover:text-green-900 text-sm font-medium"
                      >
                        {translations.edit}
                      </Link>
                    )}
                    {updateClientExists && (
                      <button
                        onClick={() => onRenewSubscription(client.id)}
                        className="text-blue-600 hover:text-blue-900 text-sm font-medium"
                      >
                        {translations.renew}
                      </button>
                    )}
                    {deleteClientExists && (
                      <button
                        onClick={() => onDeleteClient(client.id)}
                        className="text-red-600 hover:text-red-900 text-sm font-medium"
                      >
                        {translations.delete}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientTable;
